import _jsx from "@babel/runtime/helpers/jsx";
var _Text;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, StarRating, Text } from 'reaxl';

/**
 *  Displays KBB ratings inline with customizable label
 *  and optional clickable count value
 *
 */
function KBBInlineRatings(_ref) {
  let {
    className,
    rating,
    count,
    handleCountClick,
    label = 'Dealer'
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('display-flex align-items-center text-size-200 gap-1', className)
  }, void 0, /*#__PURE__*/_jsx(Text, {
    size: 200,
    color: "subdued",
    weight: "bold",
    className: "margin-right-2"
  }, void 0, _Text || (_Text = /*#__PURE__*/_jsx(Text, {}, void 0, "KBB.com", /*#__PURE__*/_jsx("sup", {}, void 0, "\xAE"))), ' ', label, ' ', "Rating"), /*#__PURE__*/_jsx(StarRating, {
    color: "#e8bb38",
    value: rating,
    uiContext: "single-star"
  }), !!count && /*#__PURE__*/_jsx(Button, {
    bsStyle: "text",
    onClick: handleCountClick
  }, void 0, "(", count, ")"));
}
export default KBBInlineRatings;